// Static demo-mode fill-in data for AppUsage.component.jsx.
// Shapes must match exactly what the component's rendering expects — see
// AppUsageComponent's `day`/`dayTotals`/`getSessionAppUsage` logic and
// AppUsage.config.jsx's `appUsageTableConfig` column renderers.

// Consumed as `state.timeline.sessionsByDay[0]`. `totals` feeds the Gauge/Trend
// stat cards (durationSec/idleSec seconds, activityPct 0-100 number). Each
// session is rendered by `SessionAccordionCard` (start/end moment-parseable,
// durationSec seconds, pastData boolean, typeLog string 'manual'/'automatic')
// and its `appUsage` map (appPath -> seconds) is turned into table rows by
// `getSessionAppUsage` (appName/seconds/formattedTime — appPath itself is
// never rendered, only used as the appUsage object's key and, via
// getAppNameByAppPath's last-segment fallback, as the displayed appName since
// no appNameMapping exists for a demo company).
// Anchored to "today" (UTC date) so the demo never shows a stale fixed
// date — only the calendar date shifts with real time; the times-of-day
// stay fixed, matching the original authored session shape.
const today = new Date();
const pad = (n) => String(n).padStart(2, '0');
const TODAY_ISO = `${today.getUTCFullYear()}-${pad(today.getUTCMonth() + 1)}-${pad(today.getUTCDate())}`;

export const DEMO_SESSIONS_BY_DAY = [
  {
    totals: {
      durationSec: 27000,
      idleSec: 2100,
      activityPct: 92,
    },
    sessions: [
      {
        id: 'demo-session-1',
        start: `${TODAY_ISO}T09:02:00Z`,
        end: `${TODAY_ISO}T12:47:00Z`,
        durationSec: 13500,
        pastData: false,
        typeLog: 'automatic',
        appUsage: {
          'Visual Studio Code': 7200,
          'Google Chrome': 3600,
          Slack: 1800,
          Terminal: 900,
        },
      },
      {
        id: 'demo-session-2',
        start: `${TODAY_ISO}T13:30:00Z`,
        end: `${TODAY_ISO}T17:15:00Z`,
        durationSec: 13500,
        pastData: true,
        typeLog: 'manual',
        appUsage: {
          Figma: 5400,
          Zoom: 3600,
          'Google Chrome': 2700,
          Slack: 1800,
        },
      },
    ],
  },
];

// Consumed by ReportFiltersBar's member dropdown ({ value, label }); employeeId
// / rate mirror useMembersOptionsForSelect's real option shape.
export const DEMO_MEMBERS_OPTIONS = [
  {
    value: 'demo-user',
    label: 'Ryan Mitchell (EMP-1001)',
    employeeId: 'EMP-1001',
    rate: 45,
  },
  {
    value: 'demo-user-2',
    label: 'Rachel Turner (EMP-1002)',
    employeeId: 'EMP-1002',
    rate: 38,
  },
  {
    value: 'demo-user-3',
    label: 'Michael Chen (EMP-1003)',
    employeeId: 'EMP-1003',
    rate: 52,
  },
];

// Consumed by appUsageTableConfig's CATEGORY column via classifyAppByProductivity
// (matched case-insensitively against row.appName) — arrays of app display names.
export const DEMO_FOCUS_APPS = ['Visual Studio Code', 'Figma', 'Terminal'];
export const DEMO_DISTRACTION_APPS = ['Zoom'];
